import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import ExpenseForm from '../common/ExpenseForm'
import ExpensesService from '@/services/ExpensesService'

export default function ExpenseAdd() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [submitting, setSubmitting] = useState(false)

	const handleSubmit = async payload => {
		if (submitting) return
		setSubmitting(true)
		const result = await ExpensesService.createExpense(payload)
		if (!result.success) {
			Swal.fire(
				t('expenses.add.messages.errorTitle'),
				result.error || t('expenses.add.messages.createFailed'),
				'error'
			)
			setSubmitting(false)
			return
		}
		Swal.fire(
			t('expenses.add.messages.createdTitle'),
			t('expenses.add.messages.createdSuccess'),
			'success'
		)
		navigate('/ksiegowosc/expenses')
		setSubmitting(false)
	}

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('expenses.add.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
					<ExpenseForm
						mode="add"
						onSubmit={handleSubmit}
						onCancel={() => navigate('/ksiegowosc/expenses')}
						submitting={submitting}
					/>
				</div>
			</div>
		</div>
	)
}
